import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Util } from '../services/Util';

@Injectable()
export class SubdomainInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const subdomain = Util.getSubdomain();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // e.g., "Africa/Lagos"
    request = request.clone({
        setHeaders : {
            subdomain: subdomain,
            'X-TimeZone': userTimeZone
        }            
      });      
    return next.handle(request);
  }

  

}
